import { getThemeValue } from './getTheme';
import { createParser } from './createParser';
import css from './css';
import type { Brand, BrandScaleKeys } from '../types/brand';

/** The component prop variant key, @default `variant` */
export type VariantPropNameKeys = 'variant' | string;

export type Variant = <
  VariantPropName extends VariantPropNameKeys = 'variant',
  VariantScaleKeys = BrandScaleKeys,
>(props: {
  /** Component prop, @default `variant` */
  prop?: VariantPropName;
  /** Theme key for variant definitions */
  scale?: VariantScaleKeys;
}) => (...args: any[]) => any;

export const variant: Variant = ({ scale, prop = 'variant' }) => {
  const sx = (value: string | number | undefined, scale: BrandScaleKeys, props: { theme: Brand | undefined }) =>
    css(getThemeValue(scale, value, undefined))(props.theme);

  sx.scale = scale;

  const parser = createParser({
    [prop]: sx,
  });

  return parser;
};

export default variant;
